<template>
    <div v-if="tebasan">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ tebasan.id ? 'Informasi' : 'Konfirmasi' }} Tebasan</h5>
            </b-card-header>
            <b-card-body>
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Tanggal</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(tebasan.created_at) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Supplier</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ tebasan.supplier.name }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Jumlah</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(tebasan.jumlah) }} tanaman</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Harga</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(tebasan.harga) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">DP</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(tebasan.dp) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Metode</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ tebasan.metode_pembayaran && tebasan.metode_pembayaran.name ? tebasan.metode_pembayaran.name : tebasan.metode_pembayaran }}</th>
                        </tr>
                    </table>
                </div>

                <template v-if="tebasan.pembelian_tembakaus">
                    <label class="form-control-label mt-3 pl-1">
                        Detail Pengiriman
                    </label>
                    <div class="alert alert-primary mb-1" role="alert">
                        Total Inputan : <strong class="text-nowrap">{{ formatNumber(tebasan.pembelian_tembakaus.length) }}</strong>
                    </div>
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th>No.</th>
                                <th>Kode</th>
                                <th>Berat</th>
                                <th>Grade</th>
                                <th>Tagihan</th>
                                <th>Pengirim</th>
                                <th>Penerima</th>
                                <th></th>
                            </tr>
                            <tr v-for="(item, index) in tebasan.pembelian_tembakaus">
                                <th class="text-primary pl-0">
                                    {{ index+1 }}
                                </th>
                                <th class="text-primary pl-0">
                                    {{ formatValue(item.code) }}
                                </th>
                                <th class="text-primary">
                                    {{ item.bobot ? formatNumber(item.bobot) + ' KG' : '-' }}
                                </th>
                                <th class="text-primary">
                                    {{ item.grade ? item.grade.name : '-' }}
                                </th>
                                <th class="text-primary">
                                    {{ item.pembayaran_supplier ? formatNumber(item.pembayaran_supplier.total_harga) : '-' }}
                                </th>
                                <th class="text-primary">
                                    {{ item.pengirim ? item.pengirim : '-' }}
                                </th>
                                <th class="text-primary pr-0">
                                    {{ item.penerima ? item.penerima : '-' }}
                                </th>
                                <th class="fit-column text-center">
                                    <button :disabled="isLoading" type="button" title="Print QrCode" @click="printQrCode(item)" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                                </th>
                            </tr>
                        </table>
                    </div>
                </template>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button v-if="isKonfirmasi" @click="$emit('koreksi')" type="button" class="btn btn-secondary">Koreksi</button>
                <button v-if="isKonfirmasi" @click="$emit('saved')" type="button" class="btn btn-primary mr-2">OK</button>
                <button v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button v-if="!isKonfirmasi" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "tebasan-viewer",

    props: {
        isKonfirmasi: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        },
    },

    components: {
    },

    data() {
        return {
            tebasan: null,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initTebasan();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.initTebasan();
        }
    },

    methods: {
        initTebasan() {
            let self = this;

            self.tebasan = Object.assign({}, self.value);
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/tebasans/print/'+self.tebasan.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        save() {
            let self = this;
            self.$emit('saved', response.data.data);
        },

        printQrCode(data) {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pembelian-tembakaus/print/' + data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
